import { useMemo } from "react";
import { useGetSeasonQuery, useGetSeasonsQuery } from "./seasonEndpoints";
import { Season } from "../../entities/season";
import { Ids } from "../../reducers/rhapsody";

export function useSeason(ids?: Ids) {
  const seasonQuery = useGetSeasonQuery(ids, {
    skip: (ids?.id ?? 0) <= 0,
  });
  const seasonEntity = seasonQuery.data;

  return useMemo(() => {
    const ret: typeof seasonQuery & { season?: Season | undefined } = {
      ...seasonQuery,
    };
    if (seasonEntity) ret.season = new Season(seasonEntity);
    return ret;
  }, [seasonEntity]);
}

export function useSeasons() {
  const seasonQuery = useGetSeasonsQuery();
  const seasonEntitiesMap = seasonQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof seasonQuery & {
      seasons?: Season[];
      seasonsMap?: { [id: number]: Season };
    } = {
      ...seasonQuery,
      seasons: [],
      seasonsMap: {},
    };
    if (seasonEntitiesMap) {
      const seasons: Season[] = [];
      const seasonsMap: { [id: number]: Season } = {};

      for (const key in seasonEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(seasonEntitiesMap, key)) {
          const c = seasonEntitiesMap[key];
          const season = new Season(c);
          seasons.push(season);
          seasonsMap[season.id] = season;
        }
      }

      seasons.sort((a, b) => b.id - a.id);
      ret.seasons = seasons;
      ret.seasonsMap = seasonsMap;
    }

    return ret;
  }, [seasonEntitiesMap]);
}
